// extracted by mini-css-extract-plugin
export default {"Blankslate":"archive-empty-states-module__Blankslate--z2hsN","Octicon":"archive-empty-states-module__Octicon--ewqar"};